import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { IStoreState } from "../../../../reducers/types";

import { TravelWalletSelection } from "./component";
import {
  getCreditToApply,
  getFetchApplicableTravelWalletItemsCallState,
  getIsTravelWalletCreditPaymentOnly,
  getIsTravelWalletOfferPaymentOnly,
  getOffers,
  getOfferToApply,
  getRewardsPaymentAccountReferenceId,
  getSelectedPaymentMethodId,
  getIsStackedTravelWalletPaymentOnly,
  getBestOfferOverall,
  getMaxApplicableTravelWalletCreditAmount,
  getApplicableCredit,
  getApplicableCreditsBreakdown,
  getIneligibleCreditsBreakdown,
  getPriceQuote,
  getPricingEstimateTotal,
} from "../../reducer";
import {
  setOfferToApply,
  setSelectedRewardsPaymentTotal,
  resetPaymentCardSelectedAccounts,
  setCreditToApply,
} from "../../actions/actions";
import {
  getTravelCreditsHistoryTransaction,
  getPartialHistoryValidFromTime,
  getAllTravelWalletOffers,
} from "../../../travel-wallet/reducer";
import { getRewardsAccounts } from "../../../rewards/reducer";

const mapStateToProps = (state: IStoreState) => {
  const priceQuote = getPriceQuote(state);
  const estimatePayNow = getPricingEstimateTotal(state);
  const bookingTotal =
    priceQuote?.vehAvail.rentalRate.payNow.fiat.value ??
    estimatePayNow?.fiat.value ??
    0;
  return {
    offers: getOffers(state),
    offerToApply: getOfferToApply(state),
    fetchApplicableTravelWalletItemsCallState:
      getFetchApplicableTravelWalletItemsCallState(state),
    selectedPaymentMethodId: getSelectedPaymentMethodId(state) ?? "",
    selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
    credits: getApplicableCredit(state),
    creditBreakdown: getApplicableCreditsBreakdown(state),
    creditsToApply: getCreditToApply(state),
    isStackedTravelWalletPaymentOnly:
      getIsStackedTravelWalletPaymentOnly(state),
    isTravelCreditPaymentOnly: getIsTravelWalletCreditPaymentOnly(state),
    isTravelWalletOfferPaymentOnly: getIsTravelWalletOfferPaymentOnly(state),
    creditsHistoryTransaction: getTravelCreditsHistoryTransaction(state),
    bestOverallOffer: getBestOfferOverall(state),
    rewardsAccounts: getRewardsAccounts(state),
    maxApplicableTravelWalletCredit:
      getMaxApplicableTravelWalletCreditAmount(state),
    ineligibleCreditsBreakdown: getIneligibleCreditsBreakdown(state),
    bookingTotal,
    partialHistoryValidFromTime: getPartialHistoryValidFromTime(state),
    allWalletOffers: getAllTravelWalletOffers(state),
  };
};

export const mapDispatchToProps = {
  setOfferToApply,
  resetPaymentCardSelectedAccounts,
  setSelectedRewardsPaymentTotal,
  setCreditToApply,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type TravelWalletSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedTravelWalletSelection = withRouter(
  connector(TravelWalletSelection),
);
